/**
 * Timecode of a key moment: a button that plays a 20-second clip, or a plain
 * label when the record has no player or the time cannot be played.
 */

import { cn } from '@/lib/utils';

/** Length of the clip a timecode plays. */
const CLIP_SECONDS = 20;

interface KeyMomentTimeProps {
  time: string;
  startSeconds?: number;
  onPlaySegment?: (startSeconds: number, durationSeconds?: number) => void;
  /** Tone of the surface the timecode sits on (a `-dim` fill takes its `-fg`). */
  className?: string;
}

export function KeyMomentTime({
  time,
  startSeconds,
  onPlaySegment,
  className,
}: KeyMomentTimeProps) {
  const playable = startSeconds !== undefined && !!onPlaySegment;
  return (
    <button
      type="button"
      disabled={!playable}
      onClick={() => {
        if (startSeconds !== undefined) {
          onPlaySegment?.(startSeconds, CLIP_SECONDS);
        }
      }}
      className={cn(
        'min-w-8 font-mono text-fg-muted',
        playable &&
          'text-primary hover:text-primary-hover underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className
      )}
    >
      {time}
    </button>
  );
}
